/* ==================================================================
   LAST AUTHORITY — interactividad del tema (JavaScript plano)
   Tres piezas: revelado al entrar, carrusel de catálogo y visor de fotos.
   Sin dependencias. Todo degrada bien si el JS falla o está desactivado.
   ================================================================== */
(function () {
  'use strict'

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches

  /* ---------------------------------------------------------------
     1. REVELADO AL ENTRAR
     El observador es la vía rápida; una medición por temporizador es
     el respaldo. Los observadores NO disparan en pestañas ocultas ni
     en algunos previews, y sin respaldo el bloque se quedaría en
     opacidad 0 para siempre: un producto sin nombre ni precio.
     --------------------------------------------------------------- */
  function iniciarRevelado() {
    var objetivos = [].slice.call(document.querySelectorAll('[data-la-reveal]'))
    if (objetivos.length === 0) return

    if (reduceMotion) {
      objetivos.forEach(function (el) {
        el.classList.add('is-in')
      })
      return
    }

    // solo ahora se esconde: si el JS nunca corre, el contenido queda visible
    objetivos.forEach(function (el) {
      el.classList.add('la-reveal')
    })

    var pendientes = objetivos.slice()

    function mostrar(el) {
      el.classList.add('is-in')
      var i = pendientes.indexOf(el)
      if (i > -1) pendientes.splice(i, 1)
      if (pendientes.length === 0) {
        clearInterval(timer)
        if (io) io.disconnect()
      }
    }

    var io = null
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(function (e) {
            if (e.isIntersecting) mostrar(e.target)
          })
        },
        { rootMargin: '-8% 0px' }
      )
      objetivos.forEach(function (el) {
        io.observe(el)
      })
    }

    function revisar() {
      var alto = window.innerHeight || 800
      pendientes.slice().forEach(function (el) {
        var r = el.getBoundingClientRect()
        if (r.top < alto * 0.92 && r.bottom > 0) mostrar(el)
      })
    }
    var timer = setInterval(revisar, 300)
    revisar()
  }

  /* ---------------------------------------------------------------
     2. CARRUSEL DE CATÁLOGO
     El scroll vertical de la página nunca se secuestra: el cliente
     arrastra, desliza o usa las flechas.
     --------------------------------------------------------------- */
  function iniciarCarruseles() {
    var filas = [].slice.call(document.querySelectorAll('[data-la-row]'))
    filas.forEach(function (fila) {
      var pista = fila.querySelector('[data-la-track]')
      var prev = fila.querySelector('[data-la-prev]')
      var next = fila.querySelector('[data-la-next]')
      if (!pista || !prev || !next) return

      function estado() {
        var max = pista.scrollWidth - pista.clientWidth
        prev.disabled = pista.scrollLeft <= 8
        next.disabled = pista.scrollLeft >= max - 8
      }

      function mover(dir) {
        var tarjeta = pista.querySelector('li')
        var paso = tarjeta ? tarjeta.getBoundingClientRect().width + 24 : pista.clientWidth * 0.8
        pista.scrollBy({ left: dir * paso, behavior: reduceMotion ? 'auto' : 'smooth' })
      }

      prev.addEventListener('click', function () {
        mover(-1)
      })
      next.addEventListener('click', function () {
        mover(1)
      })
      pista.addEventListener('scroll', estado, { passive: true })
      window.addEventListener('resize', estado)
      setInterval(estado, 500) // los temporizadores sí corren con el rAF pausado
      estado()
    })
  }


  /* ---------- ningun video que deba ir solo se queda pausado ----------
     El navegador pausa los videos cuando la pestana pasa a segundo plano y NO
     los reanuda al volver: el cliente encontraria la gorra congelada. Vale
     tanto para el 360 de la portada como para el de cada ficha.
     Comprobado en la tienda: el video arranca, avanza y se queda clavado en
     cuanto la pestana se oculta.
     Un video que YA TERMINO no se toca: el intro de Toño se ve una sola vez y,
     sin esa condicion, volver a la pestana lo arrancaria desde el principio.
     Si este script no corre no se rompe nada: los videos ya traen autoplay y,
     en el peor caso, se ve un cuadro fijo de la gorra. */
  function cuidarVideos() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    function reanudar() {
      if (document.hidden) return
      var videos = document.querySelectorAll('video[autoplay]')
      for (var i = 0; i < videos.length; i++) {
        var v = videos[i]
        if (!v.paused || v.ended || !v.getBoundingClientRect().width) continue
        var intento = v.play()
        /* si el navegador lo rechaza no hay nada que hacer y no vale un error */
        if (intento && intento.catch) intento.catch(function () {})
      }
    }

    document.addEventListener('visibilitychange', reanudar)
    window.addEventListener('pageshow', reanudar)
    document.addEventListener('loadeddata', reanudar, true)
    reanudar()
  }

  /* ---------- portada: Toño y despues la gorra girando sin fin ----------
     Dos videos encimados (sections/la-opening.liquid). El intro se ve una vez y
     acaba en la gorra; el giro es UNA vuelta exacta que empieza en el cuadro que
     sigue al ultimo del intro (lo prepara y lo comprueba
     _scripts/video_portada_gansters.py), asi que al pasar de uno al otro la
     gorra sigue su giro sin saltar.
     El giro espera cargado y parado. Se le da play cuando el intro pinta su
     ULTIMO cuadro (requestVideoFrameCallback) y el intro se esconde en cuanto el
     giro pinto el suyo: nunca queda un hueco. Donde no existe
     requestVideoFrameCallback se usa el evento `ended`.
     Si este script no corre, el intro se ve igual y se queda quieto en la gorra. */
  function introPortada() {
    var intro = document.querySelector('[data-la-intro]')
    var giro = document.querySelector('[data-la-giro]')
    if (!intro || !giro) return
    var seccion = intro.closest('.la-opening')

    if (reduceMotion) {
      intro.removeAttribute('autoplay')
      intro.pause()
      return
    }

    var cambiado = false

    function mostrarGiro() {
      seccion.setAttribute('data-la-fase', 'giro')
    }

    function aGiro() {
      if (cambiado) return
      cambiado = true
      /* sin autoplay, cuidarVideos ya no lo toca; con autoplay, el giro si se
         reanuda cuando la pestana se oculta y regresa */
      intro.removeAttribute('autoplay')
      giro.setAttribute('autoplay', '')
      var p = giro.play()
      if (p && p.catch) p.catch(function () {})
      if (giro.requestVideoFrameCallback) {
        giro.requestVideoFrameCallback(mostrarGiro)
      } else {
        giro.addEventListener('playing', function () {
          requestAnimationFrame(mostrarGiro)
        })
      }
      /* red de seguridad por si el navegador no avisa del primer cuadro */
      setTimeout(mostrarGiro, 600)
    }

    intro.addEventListener('ended', aGiro)

    if (intro.requestVideoFrameCallback) {
      var vigilar = function (ahora, datos) {
        var d = intro.duration
        if (d && datos.mediaTime >= d - 1.5 / 24) {
          aGiro()
        } else if (!cambiado) {
          intro.requestVideoFrameCallback(vigilar)
        }
      }
      intro.requestVideoFrameCallback(vigilar)
    }

    /* si ninguna fuente del intro carga, directo al giro */
    var fuentes = intro.querySelectorAll('source')
    if (fuentes.length) fuentes[fuentes.length - 1].addEventListener('error', aGiro)

    /* si el navegador no deja arrancar videos solos (ahorro de bateria), en vez
       del primer cuadro del estudio se ensena la gorra quieta */
    var intento = intro.play()
    if (intento && intento.catch) {
      intento.catch(function (e) {
        if (e && e.name === 'NotAllowedError') seccion.setAttribute('data-la-fase', 'quieta')
      })
    }
  }

  /* ---------- la animacion 360 de la ficha arranca sola ----------
     Fabric mete los videos de producto dentro de <deferred-media>, que solo
     carga el video cuando alguien pica el poster. El atributo `autoplay` que le
     pasamos desde product-media.liquid NO basta: lo comprobe leyendo su
     assets/media.js, ahi el autoplay solo se consulta DESPUES de que loadContent
     ya corrio, y a loadContent solo lo llama el clic. Nada lo dispara solo.

     Aqui se llama a showDeferredMedia(), que es el metodo publico del propio
     componente de Fabric: se usa su API, no se pelea con ella.

     Si este script no corre no se rompe nada: queda el poster con su boton de
     play, que es el comportamiento de fabrica. */
  function iniciarVideo360() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    function arrancarVisibles() {
      var cajas = document.querySelectorAll('deferred-media[autoplay]')
      for (var i = 0; i < cajas.length; i++) {
        var caja = cajas[i]
        /* la ficha pinta dos copias, la rejilla y el carrusel del telefono; la
           que esta oculta mide 0 y no vale la pena bajarle el video */
        if (!caja.getBoundingClientRect().width) continue
        if (!caja.hasAttribute('data-media-loaded')) {
          if (typeof caja.showDeferredMedia === 'function') {
            caja.showDeferredMedia()
          } else {
            var boton = caja.querySelector('.deferred-media__poster-button')
            if (boton) boton.click()
          }
        }
        /* Y ademas hay que darle play A MANO. Fabric guarda el <video> dentro de
           un <template> y lo clona al abrirlo; un video clonado de un template
           ya no dispara su propio autoplay en Chrome, asi que se queda parado en
           el primer cuadro. Medido en la tienda: el de la portada (que no pasa
           por template) arrancaba solo y el de la ficha se quedaba en 0.00 s. */
        var v = caja.querySelector('video')
        if (v && v.paused) {
          v.muted = true
          var pr = v.play()
          if (pr && pr.catch) pr.catch(function () {})
        }
      }
    }

    arrancarVisibles()
    /* el componente de Fabric se define desde un modulo: puede no estar listo
       en el primer intento, asi que se reintenta un rato */
    var vueltas = 0
    var reloj = setInterval(function () {
      arrancarVisibles()
      if (++vueltas > 12) clearInterval(reloj)
    }, 400)
    window.addEventListener('resize', arrancarVisibles)

    /* El visor grande (el que se abre al tocar la foto) pinta SU PROPIA copia
       del video, dentro de un <dialog>. Mientras el dialogo esta cerrado esa
       copia mide 0 y arrancarVisibles la salta, asi que al abrirlo y deslizar
       hasta el 360 salia congelado en el primer cuadro. Se vigila el atributo
       `open` del dialogo para arrancarla justo cuando se abre, y para pararla
       al cerrar y no dejarla corriendo de fondo. */
    var dialogos = document.querySelectorAll('zoom-dialog dialog')
    if (dialogos.length && window.MutationObserver) {
      var vigia = new MutationObserver(function (cambios) {
        for (var c = 0; c < cambios.length; c++) {
          var dlg = cambios[c].target
          if (dlg.hasAttribute('open')) {
            /* dos pasadas: al abrir, el dialogo todavia no tiene medidas */
            requestAnimationFrame(arrancarVisibles)
            setTimeout(arrancarVisibles, 120)
          } else {
            var dentro = dlg.querySelectorAll('video')
            for (var k = 0; k < dentro.length; k++) dentro[k].pause()
          }
        }
      })
      for (var d = 0; d < dialogos.length; d++) {
        vigia.observe(dialogos[d], { attributes: true, attributeFilter: ['open'] })
      }
    }
  }

  /* La pieza destacada de la portada gira. No hace falta arrancarla ni pararla
     a mano segun se vea o no: los navegadores ya paran solos los videos que no
     estan en pantalla para ahorrar bateria. Se comprobo en la consola del
     propio sitio: "The play() request was interrupted because video-only
     background media was paused to save power". Duplicar eso con un
     IntersectionObserver era codigo de mas, y encima no verificable desde aqui.

     Lo unico que si hay que hacer a mano es respetar a quien pide menos
     animacion: se le quita el autoplay y se deja quieta. Un <video> parado
     ensena su poster, que es el primer cuadro del giro. */
  function giroDestacada() {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    var v = document.querySelector('.la-spotlight__giro')
    if (!v) return
    v.removeAttribute('autoplay')
    v.pause()
  }

  /* "Tambien te gustaran": la seccion pinta TODAS las gorras y Liquid marca ya
     las primeras con `data-elegida`, que son las que el CSS deja ver. Aqui se
     quitan esas marcas y se reparten al azar. Se hace en el navegador y no en
     Liquid porque Shopify cachea el HTML en su CDN: un sorteo hecho en el
     servidor se quedaria congelado para todos hasta que caduque la cache.

     Fisher-Yates, que reparte parejo. Si este guion no corre, no pasa nada:
     quedan las que marco Liquid, que son exactamente las que pide el ajuste. */
  function barajarRelacionados() {
    var secciones = document.querySelectorAll('[data-la-rel]')
    for (var s = 0; s < secciones.length; s++) {
      var sec = secciones[s]
      var items = [].slice.call(sec.querySelectorAll('[data-la-rel-item]'))
      if (items.length === 0) continue
      var cuantas = parseInt(sec.getAttribute('data-cuantas'), 10) || 4

      for (var q = 0; q < items.length; q++) items[q].removeAttribute('data-elegida')

      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1))
        var tmp = items[i]
        items[i] = items[j]
        items[j] = tmp
      }
      var lista = sec.querySelector('[data-la-rel-lista]')
      for (var k = 0; k < items.length && k < cuantas; k++) {
        items[k].setAttribute('data-elegida', '')
        /* al final de la lista, para que salgan en el orden del sorteo */
        lista.appendChild(items[k])
      }
    }
  }

  function arrancar() {
    iniciarRevelado()
    iniciarCarruseles()
    cuidarVideos()
    introPortada()
    iniciarVideo360()
    giroDestacada()
    barajarRelacionados()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar)
  } else {
    arrancar()
  }
})()
